import { useCallback } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useDynamicQueryParamKey } from '@telialt/common-hooks/src/useDynamicQueryParamKey';

import { Commitment, OfferGroup } from '../model';
import { getAvailableCommitments } from '../utils';

export const useCommitmentChange = (availableCommitmentTypes: Commitment[], offerGroup: OfferGroup) => {
    const { t } = useTranslations();

    const nboSearchParam = t['plans.plans_list.commitment.NBO_search_param'];
    const availableCommitments = getAvailableCommitments(t, availableCommitmentTypes, offerGroup);
    const commitmentKeys = availableCommitments.map((option) => option?.paramKey);

    const [currentCommitmentKey, setCommitmentKey] = useDynamicQueryParamKey({
        possibleKeys: commitmentKeys,
    });

    const isSwitchTarget = useCallback(
        (key: string | undefined | null) => Boolean(key) && key !== nboSearchParam && key !== currentCommitmentKey,
        [nboSearchParam, currentCommitmentKey],
    );

    const hasAnotherCommitment = commitmentKeys.some((key) => isSwitchTarget(key));

    const handleCommitmentChange = useCallback(() => {
        const nextCommitmentKey = commitmentKeys.find((key) => isSwitchTarget(key));
        if (!nextCommitmentKey) {
            return;
        }

        setCommitmentKey(nextCommitmentKey);
    }, [commitmentKeys, isSwitchTarget, setCommitmentKey]);

    return {
        handleCommitmentChange,
        hasAnotherCommitment,
    };
};
